addEventListener("DOMContentLoaded", (event) => {
  console.log('-- custom javascript loaded --')
  
  const moneyFormat = '${{amount}}';
  var headerConfigs = {
    credentials: "same-origin",
    headers: {
      "Content-Type": "application/json",
      "X-Requested-With": "xmlhttprequest",
    },
  };
  
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    let value = '';
    const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    const formatString = format || moneyFormat;
  
    function formatWithDelimiters(
      number,
      precision = 2,
      thousands = ',',
      decimal = '.'
    ) {
      if (isNaN(number) || number == null) {
        return 0;
      }
  
      number = (number / 100.0).toFixed(precision);
  
      const parts = number.split('.');
      const dollarsAmount = parts[0].replace(
        /(\d)(?=(\d\d\d)+(?!\d))/g,
        `$1${thousands}`
      );
      const centsAmount = parts[1] ? decimal + parts[1] : '';
  
      return dollarsAmount + centsAmount;
    }
  
    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_comma_separator':
        value = formatWithDelimiters(cents, 2, '.', ',');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, '.', ',');
        break;
    }
  
    return formatString.replace(placeholderRegex, value);
  }
  
  async function getCart() {
    var response = await fetch(`${window.Shopify.routes.root}cart.js`)
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }
  
  async function updateCart(updates) {
    console.log('updates: ', `${window.Shopify.routes.root}cart/update.js`, {
      updates: updates
    });

    var response = await fetch(`${window.Shopify.routes.root}cart/update.js`, Object.assign(headerConfigs, {
      method: "POST",
      body: JSON.stringify({
        updates: updates
      })
    }))
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }
  
  async function changeItemsInCart(changes) {
    var response = await fetch(`${window.Shopify.routes.root}cart/change.js`, Object.assign(headerConfigs, {
      method: "POST",
      body: JSON.stringify(changes)
    }))
    
    if (!response.ok) {
      console.log('response: ', response)
      throw new Error(`HTTP error! status: ${response.status}`);
    }
    
    var data = await response.json()
    return data
  }

  /**
   * Size & frame selector (frame-selection block, snippets/pl-product-blocks.liquid).
   *
   * Ported from Envy 32 to Envy 36. The size rows are the variant picker
   * (Envy's own options block is hidden in custom.css): choosing a size
   * clicks the matching item in Envy's variant dropdown so Envy updates the
   * page as usual. Choosing a frame writes it to the hidden linked_frame_*
   * inputs, which submit with Envy's product form via their `form` attribute,
   * and shows print + frame price.
   */
  document.querySelectorAll('[data-pl-frame-tool]').forEach(tool => {
    var section = tool.closest('.shopify-section') || document;
    var sizeRadios = Array.from(tool.querySelectorAll('input[name="radio-id"]'));
    var linked = {
      frame: tool.querySelector('[data-props-linked-frame]'),
      variant: tool.querySelector('[data-props-linked-variant]'),
      sku: tool.querySelector('[data-props-linked-sku]'),
      title: tool.querySelector('[data-props-linked-title]'),
    };

    var rowFor = radio => radio && radio.closest('.frame-option');
    var checkedSize = () => sizeRadios.find(r => r.checked) || null;
    var clearLinked = () => Object.values(linked).forEach(input => { if (input) input.value = ''; });

    function showFramesFor(sizeRadio) {
      tool.querySelectorAll('.frames-outer').forEach(el => { el.style.display = 'none'; });
      tool.querySelectorAll('[data-frame-value]').forEach(input => { input.checked = false; });
      sizeRadios.forEach(r => {
        var rowPrice = rowFor(r).querySelector('.frame-price');
        if (rowPrice) rowPrice.innerHTML = formatMoney(r.dataset.price);
      });
      clearLinked();

      var row = rowFor(sizeRadio);
      if (!row || row.classList.contains('soldout') || !row.querySelector('.child-variants')) return;
      var outer = row.querySelector('.frames-outer');
      if (outer) outer.style.display = 'block';
      var unframed = row.querySelector('[value="unframed-print-only"]');
      if (unframed) unframed.checked = true;
    }

    // The size row and the price at the top keep the print's price, and each
    // frame shows "+$215"; the total (print + frame) is the price inside the
    // Add to Cart button, which Envy resets to the print's price on a size change.
    function updatePrice(sizeRadio, frameInput) {
      var extra = frameInput && frameInput.value !== 'unframed-print-only' ? Number(frameInput.dataset.price) : 0;
      var total = formatMoney(Number(sizeRadio.dataset.price) + extra);
      section.querySelectorAll('.product-price-on-button').forEach(el => { el.innerHTML = total; });
    }

    // Picking a frame shows the photo of the print in that frame, found by its
    // alt text ("... in a white frame" or "... in white frame").
    // With no photo for that color, or Unframed, the gallery goes back to the
    // first image, the print itself.
    function showFramedPhoto(frameInput) {
      var color = frameInput.value === 'unframed-print-only' ? '' :
        ((frameInput.dataset.frameTitle || '').split('/')[1] || '').trim();
      var pattern = color && new RegExp('\\bin (?:an? )?' + color.replace(/[.*+?^${}()|[\]\\]/g, '\\$&') + '\\b[^.]*frame', 'i');
      (section.querySelector('[data-media-id]') ? section : document).querySelectorAll('.swiper').forEach(el => {
        var swiper = el.swiper;
        if (!swiper || !swiper.slides) return;
        var slides = Array.from(swiper.slides).filter(s => s.dataset.mediaId && !s.classList.contains('swiper-slide-duplicate'));
        if (!slides.length) return;
        var target = pattern && slides.find(s => pattern.test((s.querySelector('img') || {}).alt || ''));
        target = target || slides[0];
        // slideTo, not slideToLoop: on the fading main gallery slideToLoop doesn't move.
        swiper.slideTo(Array.from(swiper.slides).indexOf(target));
      });
    }

    function selectVariantInEnvy(sizeRadio) {
      var title = rowFor(sizeRadio).dataset.frameVariantTitle;
      var item = Array.from(section.querySelectorAll('[data-product-variant][data-option-value]'))
        .find(el => el.dataset.optionValue === title);
      if (item) {
        item.click();
        return;
      }
      // No matching dropdown item (e.g. a product with more than one option):
      // set the variant on the form directly so the right size is added.
      var form = document.getElementById(tool.dataset.productFormId);
      var idInput = form && form.querySelector('input[name="id"]');
      if (idInput) idInput.value = sizeRadio.value;
    }

    tool.addEventListener('change', e => {
      var target = e.target;
      if (target.name === 'radio-id') {
        showFramesFor(target);
        selectVariantInEnvy(target);
      } else if (target.hasAttribute('data-frame-value')) {
        var size = checkedSize();
        if (!size) return;
        updatePrice(size, target);
        showFramedPhoto(target);
        if (target.value === 'unframed-print-only') {
          clearLinked();
          return;
        }
        linked.frame.value = target.dataset.frameValue;
        linked.variant.value = target.value;
        linked.sku.value = target.dataset.sku || '';
        linked.title.value = target.dataset.frameTitle || '';
      }
    });

    // Keep the size rows in sync when the variant changes another way.
    if (window.eventBus) {
      window.eventBus.on('variant:change', payload => {
        var variant = payload && payload.variant;
        var id = variant && String(variant.id || variant);
        var match = id && sizeRadios.find(r => r.value === id);
        if (match && !match.checked) {
          match.checked = true;
          showFramesFor(match);
        }
      });
    }

    showFramesFor(checkedSize());

    /**
     * Add print + frame as a bundle, exactly as the Envy 32 theme did: one
     * /cart/add request with two items sharing a random _bundleId. The print
     * carries the frame details as properties; the cart page and order
     * processing rely on these names.
     *
     * Envy's <product-form> builds its request in fetchConfigWithBody(); when
     * a frame is selected we swap in the bundle body and leave the rest of
     * Envy's flow (loading state, errors, added message / redirect) alone.
     */
    var productForm = document.getElementById(tool.dataset.productFormId);
    var formComponent = productForm && productForm.closest('product-form');
    if (formComponent) {
      customElements.whenDefined('product-form').then(() => {
        var buildRequest = formComponent.fetchConfigWithBody.bind(formComponent);
        formComponent.fetchConfigWithBody = () => {
          var config = buildRequest();
          var frame = tool.querySelector('[data-frame-value]:checked');
          if (!frame || frame.value === 'unframed-print-only' || !linked.variant.value) return config;

          var formData = new FormData(productForm);
          var quantity = Number(formData.get('quantity')) || 1;
          var bundleId = Math.floor(Math.random() * (999999999 - 9999) + 9999);
          var body = {
            items: [
              {
                id: Number(formData.get('id')),
                quantity: quantity,
                properties: {
                  linked_frame_sku: linked.sku.value || null,
                  linked_frame: Number(linked.variant.value),
                  _linked_frame_title: linked.title.value || null,
                  _bundleId: bundleId,
                },
              },
              { id: Number(linked.variant.value), quantity: quantity, properties: { _bundleId: bundleId } },
            ],
          };
          if (formComponent.cartType === 'drawer') body.sections = 'cart-drawer';

          config.headers['Content-Type'] = 'application/json';
          config.headers['Accept'] = 'application/json';
          config.body = JSON.stringify(body);
          return config;
        };
      });
    }
  });

  /**
   * Keep print + frame bundles consistent in the cart (ported to Envy 36).
   *
   * A bundle is a print and a Custom Frame sharing a _bundleId property
   * (added by the size & frame selector above). After any cart change:
   * - print removed       -> remove its frame too
   * - frame removed       -> clear the frame details from the print
   * - print qty changed   -> frame qty follows
   * Envy emits update:cart:drawer after every cart change, on the cart page
   * as well as the drawer. If anything was fixed, reload so the cart shows it.
   */
  var reconcilingBundles = false;
  var reconcileBundles = async () => {
    if (reconcilingBundles) return;
    reconcilingBundles = true;
    try {
      var cart = await getCart();
      var bundles = {};
      cart.items.forEach(item => {
        var id = item.properties && item.properties._bundleId;
        if (!id) return;
        bundles[id] = bundles[id] || { prints: [], frames: [] };
        bundles[id][item.product_type === 'Framing' ? 'frames' : 'prints'].push(item);
      });

      var updates = {};
      var clearPrints = [];
      Object.values(bundles).forEach(b => {
        var print = b.prints[0];
        b.frames.forEach(frame => {
          if (!print) updates[frame.key] = 0;
          else if (frame.quantity !== print.quantity) updates[frame.key] = print.quantity;
        });
        if (print && b.frames.length === 0) clearPrints.push(print);
      });

      if (clearPrints.length === 0 && Object.keys(updates).length === 0) return;

      // Shopify can't clear line item properties in place, so a print whose
      // frame was removed is replaced with the same variant and quantity,
      // without the frame properties.
      for (var print of clearPrints) {
        await changeItemsInCart({ id: print.key, quantity: 0 });
        await fetch(`${window.Shopify.routes.root}cart/add.js`, {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [{ id: print.variant_id, quantity: print.quantity }] }),
        });
      }
      if (Object.keys(updates).length > 0) await updateCart(updates);

      // Only reload if the cart really changed, so this can never loop.
      var signature = c => c.items.map(i => `${i.key}:${i.quantity}`).join('|');
      var after = await getCart();
      if (signature(after) !== signature(cart) && window.location.pathname.includes('/cart')) {
        window.location.reload();
      }
    } catch (e) {
      console.error('Bundle reconcile failed:', e);
    } finally {
      reconcilingBundles = false;
    }
  };

  /**
   * Hover zoom on the main product image (desktop with a mouse), as on the
   * Envy 32 site; Envy 36 has no zoom. The image scales up in place and
   * follows the cursor, and its sizes attribute is raised so the browser
   * loads a sharp, high-resolution copy.
   */
  if (window.matchMedia('(hover: hover) and (min-width: 1025px)').matches) {
    // Envy's desktop media slider stacks every slide, and which one is on top
    // doesn't always match Swiper's "active" slide. So scale the whole stack
    // with the CSS scale property (Swiper itself uses transform, which this
    // leaves alone): whichever image is showing gets zoomed.
    var zoomed = null;
    var resetZoom = () => {
      if (zoomed) zoomed.style.scale = '';
      zoomed = null;
    };
    document.addEventListener('mousemove', e => {
      var slider = e.target.closest && e.target.closest('.product-media-slider-desktop .thumbnail-media--main-media');
      if (!slider || e.target.closest('.thumb-prev, .thumb-next, button')) {
        resetZoom();
        return;
      }
      var stack = slider.querySelector('.swiper-wrapper');
      if (!stack) return;
      if (stack !== zoomed) {
        resetZoom();
        zoomed = stack;
        slider.style.overflow = 'hidden';
        slider.style.cursor = 'zoom-in';
        stack.style.transition = 'scale .4s cubic-bezier(.25, .8, .25, 1)';
        stack.querySelectorAll('img').forEach(img => { img.sizes = '2400px'; });
        stack.style.scale = '2';
      }
      var r = slider.getBoundingClientRect();
      stack.style.transformOrigin = `${(e.clientX - r.left) / r.width * 100}% ${(e.clientY - r.top) / r.height * 100}%`;
    });
    document.addEventListener('mouseout', e => {
      var to = e.relatedTarget;
      if (zoomed && !(to && to.closest && to.closest('.product-media-slider-desktop .thumbnail-media--main-media'))) resetZoom();
    });
  }

  /**
   * Thumbnail clicks for the "below" desktop thumbnail layout (an option we
   * added to template--product; Envy 36 only uses it on mobile). With all the
   * thumbnails fitting in one row, Swiper's watchOverflow locks the thumbnail
   * slider and it ignores taps, so show the clicked image ourselves. Envy's
   * thumbs module keeps the thumbnail highlight in sync.
   */
  document.addEventListener('click', e => {
    var slide = e.target.closest && e.target.closest('.product-media-slider-desktop .thumbnail-media--thumbnails .swiper-slide');
    if (!slide) return;
    var media = slide.closest('product-media');
    var main = media && media.querySelector('.thumbnail-media--main-media');
    if (!main || !main.swiper) return;
    var index = Array.prototype.indexOf.call(slide.parentElement.children, slide);
    if (index > -1 && main.swiper.activeIndex !== index) main.swiper.slideTo(index);
  }, true); // capture: Swiper stops the click from bubbling

  /**
   * Collection descriptions: clamp long ones to about the artist image's
   * height (112%) with a fade and a Read more / Read less toggle. On narrow
   * screens, where the image stacks above the text, cap at 220px.
   */
  document.querySelectorAll('[data-pl-clamp]').forEach(box => {
    var header = box.closest('.pl-collection-header');
    var img = header && header.querySelector('.collection-image-wrapper img');
    var toggle = box.parentElement.querySelector('.pl-clamp__toggle');
    if (!toggle) return;
    var wide = window.matchMedia('(min-width: 1024px)');
    var limit = () => (wide.matches && img && img.getBoundingClientRect().height > 0)
      ? Math.round(img.getBoundingClientRect().height * 1.12)
      : 220;

    var update = () => {
      if (box.classList.contains('is-expanded')) return;
      box.style.maxHeight = '';
      var max = limit();
      // Leave room for about a line before clamping, so a description that
      // barely overflows isn't hidden behind a Read more for one line.
      if (box.scrollHeight > max + 24) {
        box.style.maxHeight = max + 'px';
        box.classList.add('is-clamped');
        toggle.hidden = false;
      } else {
        box.classList.remove('is-clamped');
        toggle.hidden = true;
      }
    };

    toggle.addEventListener('click', () => {
      var expand = !box.classList.contains('is-expanded');
      box.classList.toggle('is-expanded', expand);
      box.classList.toggle('is-clamped', !expand);
      box.style.maxHeight = (expand ? box.scrollHeight : limit()) + 'px';
      toggle.setAttribute('aria-expanded', String(expand));
      toggle.textContent = expand ? 'Read less' : 'Read more';
    });

    if (img && !img.complete) img.addEventListener('load', update);
    window.addEventListener('resize', update);
    update();
  });

  /**
   * Testimonials "Slideshow" layout (sections/testimonials.liquid): one
   * testimonial at a time, fading to the next every few seconds, with dots
   * and a pause button. Hovering over or focusing a quote pauses; with reduced motion
   * it doesn't advance on its own.
   */
  document.querySelectorAll('[data-pl-testimonials]').forEach(block => {
    var slides = Array.from(block.querySelectorAll('.testimonial--single-item'));
    var controls = block.parentElement.querySelector('.pl-testimonials__controls');
    if (slides.length < 2 || !controls) return;
    var dots = Array.from(controls.querySelectorAll('[data-pl-testimonials-dot]'));
    var pauseButton = controls.querySelector('[data-pl-testimonials-pause]');
    var delay = (parseInt(block.dataset.slideTime, 10) || 4) * 1000;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    var current = 0, timer = null, paused = reduceMotion, hovering = false;

    var show = index => {
      current = (index + slides.length) % slides.length;
      slides.forEach((slide, i) => {
        slide.classList.toggle('is-active', i === current);
        slide.setAttribute('aria-hidden', String(i !== current));
        slide.querySelectorAll('a, button, input').forEach(el => { el.tabIndex = i === current ? 0 : -1; });
      });
      dots.forEach((dot, i) => dot.setAttribute('aria-current', String(i === current)));
    };
    var schedule = () => {
      clearTimeout(timer);
      if (!paused && !hovering) timer = setTimeout(() => { show(current + 1); schedule(); }, delay);
    };
    var setPaused = value => {
      paused = value;
      pauseButton.setAttribute('aria-pressed', String(paused));
      pauseButton.setAttribute('aria-label', paused ? 'Play testimonials' : 'Pause testimonials');
      schedule();
    };

    dots.forEach((dot, i) => dot.addEventListener('click', () => { show(i); schedule(); }));
    pauseButton.addEventListener('click', () => setPaused(!paused));
    // Pause while someone is reading (pointer or focus on the quotes); the
    // dots and pause button don't count, so Play takes effect right away.
    block.addEventListener('mouseenter', () => { hovering = true; schedule(); });
    block.addEventListener('mouseleave', () => { hovering = false; schedule(); });
    block.addEventListener('focusin', () => { hovering = true; schedule(); });
    block.addEventListener('focusout', () => { hovering = false; schedule(); });

    block.classList.add('is-ready');
    show(0);
    setPaused(paused);
  });

  /**
   * Collection filters in the desktop sidebar (snippets/main-collection-
   * filtering-sorting.liquid, .pl-accordion): open sections that stack, as on
   * the live site, instead of Envy's pop-ups. The <details> stay open (Envy's
   * component-filtering.js closes every <details> on an outside click, so the
   * observer reopens them) and a heading click collapses or expands its
   * section through the is-collapsed class instead.
   */
  var keepFilterOpen = new MutationObserver(records => records.forEach(record => {
    if (!record.target.open) record.target.open = true;
  }));
  document.querySelectorAll('.pl-accordion').forEach(details => {
    keepFilterOpen.observe(details, { attributes: true, attributeFilter: ['open'] });
    details.querySelector('summary').setAttribute('aria-expanded', 'true');
  });
  document.addEventListener('click', event => {
    var summary = event.target.closest('.pl-accordion > summary');
    if (!summary) return;
    event.preventDefault();
    var collapsed = summary.parentElement.classList.toggle('is-collapsed');
    summary.setAttribute('aria-expanded', String(!collapsed));
  });

  /**
   * Collapsible tabs (Envy's <collapsible-button>: product Details / Medium /
   * Why We Love It, FAQs, complementary products): expose them as buttons
   * with an expanded/collapsed state. Envy's element is a focusable div that
   * toggles on click and Enter but has no role or state. Its prototype is
   * patched (rather than editing the Envy file) so tabs loaded later, as in
   * quick view, get the same treatment. A closed tab's content is inert, so
   * its links aren't tabbed to while hidden.
   */
  var collapsibleCount = 0;
  var syncCollapsible = button => {
    var tab = button.parentElement;
    var content = button.nextElementSibling;
    if (!tab || !tab.classList.contains('collapsible-tab') || !content || !content.classList.contains('collapsible-content')) return;
    if (!content.id) content.id = `collapsible-content-${++collapsibleCount}`;
    var open = tab.classList.contains('open');
    button.setAttribute('role', 'button');
    button.setAttribute('aria-controls', content.id);
    button.setAttribute('aria-expanded', String(open));
    content.inert = !open;
  };
  customElements.whenDefined('collapsible-button').then(() => {
    var proto = customElements.get('collapsible-button').prototype;
    ['init', 'showDetails', 'hideDetails'].forEach(name => {
      var original = proto[name];
      proto[name] = function () {
        var result = original.apply(this, arguments);
        syncCollapsible(this);
        return result;
      };
    });
    document.querySelectorAll('collapsible-button').forEach(syncCollapsible);
  });
  // Space activates a button too (Envy only listens for Enter).
  document.addEventListener('keydown', event => {
    if (event.key !== ' ' || event.target.localName !== 'collapsible-button') return;
    event.preventDefault();
    event.target.toggle();
  });

  if (window.eventBus) window.eventBus.on('update:cart:drawer', () => reconcileBundles());
  if (window.location.pathname.includes('/cart')) reconcileBundles();
 
});

// 20x200: menus and page content link to full https://20x200.com/... addresses.
// On a Shopify share-preview domain (*.shopifypreview.com) those links would
// leave the preview for the live site (in a new tab, from the header), so keep
// them on the current host. On 20x200.com itself this never matches.
(function () {
  var site = /^(www\.)?20x200\.com$/i;
  if (site.test(location.hostname)) return;
  function keepOnPreview(link) {
    if (!link || !site.test(link.hostname)) return;
    link.href = location.origin + link.pathname + link.search + link.hash;
    // Envy's header opens links to other domains in a new tab; these aren't.
    link.removeAttribute('target');
    link.removeAttribute('rel');
  }
  // iOS Safari can decide on a new tab before the click event, so also fix the
  // link on touch and pointer down, and sweep the page once Envy has marked its links.
  ['touchstart', 'pointerdown', 'click'].forEach(function (type) {
    document.addEventListener(type, function (event) {
      keepOnPreview(event.target.closest && event.target.closest('a[href]'));
    }, { capture: true, passive: true });
  });
  window.addEventListener('load', function () {
    setTimeout(function () {
      document.querySelectorAll('a[href]').forEach(keepOnPreview);
    }, 500);
  });
})();

// 20x200: in the mobile menu, tapping an item that has a submenu opens it
// (as the + does) instead of following the link, as on the old site. Each
// submenu ends with its own "All ... >" link to the overview page.
document.addEventListener('click', function (event) {
  var link = event.target.closest && event.target.closest('.mobile-nav__has-sublist > a.mobile-nav__link');
  if (!link) return;
  var buttons = link.parentElement.querySelectorAll('.mobile-nav__toggle button');
  var visible = Array.prototype.find.call(buttons, function (b) { return b.offsetParent !== null; });
  if (!visible) return;
  event.preventDefault();
  visible.click();
});
